import getHeaderHeight from '../utils/getHeaderHeight';
export default class AccordionWithMedia {
  constructor() {
    this.selector = '.c-accordion-with-media';

    this.selectors = {
      accordionSection: '.c-accordion-with-media__item',
      mediasSection: '.c-accordion-with-media__medias-item',
      head: '.c-accordion-with-media__item-head',
      body: '.c-accordion-with-media__item-body',
      block: '.c-block',
      lottieAnimation: '.c-lottie-animation',
      activeItem: '.c-accordion-with-media__item--active',
    };

    this.classNames = {
      active: 'c-accordion-with-media__item--active',
      mediasActive: 'c-accordion-with-media__medias-item--active',
    };
  }

  bootstrap() {
    this.initAccordions();

    window.addEventListener('load', this.loadWithHash.bind(this));
  }

  // eslint-disable-next-line sonarjs/cognitive-complexity
  toggleAccordion({ accordionSection: currentAccordionItem, medias, type, sections }, event) {
    const { target } = event;

    if (window.innerWidth < 991 && (event.type === 'mouseover' || event.type === 'mouseout')) {
      return;
    }

    if (currentAccordionItem.classList.contains(this.classNames.active)) {
      return;
    }

    this.getAnimationIdsPerAccordionSection(currentAccordionItem);

    // If the accordion should have only one open item at a time
    if (type === 'single') {
      sections.forEach(accordionSection => {
        // Allow user to manually close the current active accordion item
        if (accordionSection === currentAccordionItem) {
          return;
        }

        const body = accordionSection.querySelector(this.selectors.body);

        accordionSection.classList.remove(this.classNames.active);
        medias.forEach(item => {
          item.classList.remove(this.classNames.mediasActive);
        });

        if (body) {
          $(body).slideUp();
        }
      });
    }

    if (target.matches([ this.selectors.head, `${this.selectors.head} *` ])) {
      const body = currentAccordionItem.querySelector(this.selectors.body);
      const currentIndex = currentAccordionItem.dataset.id;
      const section = currentAccordionItem.closest(this.selectors.block);
      const media = medias.filter(item => {
        if (item.dataset.id === currentIndex) {
          return true;
        }

        return false;
      });

      media.forEach(item => {
        item.classList.toggle(this.classNames.mediasActive);
      });

      section.dataset.currentIndex = currentIndex;
      currentAccordionItem.classList.toggle(this.classNames.active);

      if (body) {
        $(body).slideToggle();
      }
    }
  }

  hoverAccordion({ accordionSection: currentAccordionItem, medias }, event) {
    const { target } = event;

    if (currentAccordionItem.classList.contains(this.classNames.active)) {
      return;
    }

    this.getAnimationIdsPerAccordionSection(currentAccordionItem);

    if (target.matches([ this.selectors.head, `${this.selectors.head} *` ])) {
      const currentIndex = currentAccordionItem.dataset.id;

      // eslint-disable-next-line sonarjs/no-identical-functions
      const media = medias.filter(item => {
        if (item.dataset.id === currentIndex) {
          return true;
        }

        return false;
      });

      media.forEach(item => {
        item.classList.toggle(this.classNames.mediasActive);
      });
    }
  }

  initAccordions() {
    const blocks = [ ...document.querySelectorAll(this.selector) ];

    if (blocks.length === 0) {
      return;
    }

    blocks.forEach(block => {
      const { type, openFirst } = block.dataset;
      const sections = [
        ...block.querySelectorAll(this.selectors.accordionSection),
      ];
      const medias = [
        ...block.querySelectorAll(this.selectors.mediasSection),
      ];

      this.handleVideosPlay(block);

      if (sections.length === 0) {
        return;
      }

      // Show first accordion item in the block as per the condition
      if (openFirst === 'true') {
        const INITIAL_INDEX = 0;

        $(sections[0].querySelector(this.selectors.body)).slideDown();
        sections[0].classList.add(this.classNames.active);
        medias[0].classList.add(this.classNames.mediasActive);

        // eslint-disable-next-line no-param-reassign
        block.closest(this.selectors.block).dataset.currentIndex = INITIAL_INDEX;
      }

      sections.forEach(accordionSection => {
        // Attach click listener to each accordion item
        accordionSection.addEventListener(
          'click',
          this.toggleAccordion.bind(this, { accordionSection, medias, type, sections })
        );

        accordionSection.addEventListener(
          'mouseover',
          this.toggleAccordion.bind(this, { accordionSection, medias, type, sections })
        );

        accordionSection.addEventListener(
          'mouseout',
          this.toggleAccordion.bind(this, { accordionSection, medias, type, sections })
        );
      });
    });
  }

  getAnimationIdsPerAccordionSection(accordionSection) {
    const itemIndex = accordionSection.dataset.item;
    const targetTab = accordionSection.closest(this.selectors.block).querySelector(`[data-target="${itemIndex}"]`);

    const animationIds = [];
    const localAnimation = accordionSection.querySelector(this.selectors.lottieAnimation);

    if (localAnimation) {
      animationIds.push(localAnimation.dataset.id);
    }

    if (targetTab) {
      const remoteAnimation = targetTab.querySelector(this.selectors.lottieAnimation);

      if (remoteAnimation) {
        animationIds.push(remoteAnimation.dataset.id);
      }
    }

    if (window.lottieAnimations === undefined || window.lottieAnimations.length === 0) {
      return;
    }

    window.lottieAnimations.forEach(animation => {
      const { settings, animation: player } = animation;

      if (animationIds.includes(settings.nodeId)) {
        player.goToAndPlay(0, true);
      }
    });
  }

  loadWithHash() {
    const { hash } = window.location;

    if (!hash) {
      return;
    }

    const id = hash.slice(1);
    const sections = [
      ...document.querySelectorAll(this.selectors.accordionSection),
    ];

    if (sections.length === 0) {
      return;
    }

    for (const element of sections) {
      if (element.dataset.id === id) {
        element.children[0].click();

        setTimeout(() => {
          const top = element.getBoundingClientRect().top + window.scrollY - document.documentElement.clientTop - getHeaderHeight();

          window.scrollTo({
            top,
            behavior: 'smooth',
          });
        }, 500);

        break;
      }
    }
  }

  // eslint-disable-next-line class-methods-use-this
  handleVideosPlay(block) {
    const videos = [ ...block.querySelectorAll('video') ];

    if (videos.length === 0) {
      return;
    }

    const promises = [];

    videos.forEach(video => {
      promises.push(video);
    });

    Promise.all(promises)
      .then(() => {
        videos.forEach(video => {
          video.play();
        });
      });
  }
}
